<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <good-table-column-search
                :moduleapi="`${this.baseApi}/memo`"
                title="Memo"
                :columns="columns"
                routerpath="/hr/addmemo"
                :formOptions="formOptions"
                :newPage="true"
                :edit="edit"
                :add="add"
                :viewFields="viewFields"
                :canDelete="canDelete"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodTableColumnSearch from "../../../components/GoodTableColumnSearch.vue";
import moment from "moment";
const baseApi = process.env.VUE_APP_APIENDPOINT;
export default {
  components: {
    GoodTableColumnSearch,
  },
  data() {
    return {
      edit: "",
      add: "",
      canDelete: "",
      baseApi: process.env.VUE_APP_APIENDPOINT,
      viewFields: [
        {
          label: "Date",
          field: "datetime",
          type: "datetime",
          class: "col-md-4",
        },
        {
          label: "Assign To",
          field: "assignto",
          type: "dropdown",
          responseValue: "fullname",
          class: "col-md-4",
        },
        {
          label: "Subject",
          field: "subject",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Description",
          field: "description",
          type: "text",
          class: "col-md-4",
        },
        {
          label: "Amount",
          field: "amount",
          type: "text",
          class: "col-md-4",
        },
      ],
      columns: [
        {
          label: "ID",
          field: "id",
          filterOptions: {
            enabled: true,
            placeholder: "Search ID",
          },
          hidden: true,
        },
        {
          label: "Date Time",
          field: "datetime",
          type: "datetime",

          filterOptions: {
            enabled: true,
            placeholder: "Search Date Time",
          },
        },
        {
          label: "Assign To",
          field: "assignto",
          url: "getUsers",

          type: "staticdropdown",
          responseValue: "fullname",
          filterOptions: {
            enabled: true,
            placeholder: "Search Assign To",
          },
        },
        {
          label: "Subject",
          field: "subject",
          filterOptions: {
            enabled: true,
            placeholder: "Search Subject",
          },
        },
        {
          label: "Amount",
          field: "amount",
          filterOptions: {
            enabled: true,
            placeholder: "Search Amount",
          },
        },
        {
          label: "Enter By",
          field: "enterby",
          type: "staticdropdown",
          url: "getUsers",
          responseValue: "fullname",
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Enter Date",
          field: "enterdatetime",
          type: "datetime",

          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Modified By",
          field: "modifiedby",
          type: "staticdropdown",
          url: "getUsers",
          responseValue: "fullname",
          filterOptions: {
            enabled: true,
            placeholder: "Search Name",
          },
        },
        {
          label: "Modified Date",
          field: "modifieddatetime",
          type: "datetime",

          filterOptions: {
            enabled: true,
            placeholder: "Search Date",
          },
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      formOptions: {
        formTitle: `${this.$route.query.id ? "Edit Memo" : "Add Memo"}`,
        submitRouterPath: "/hr/memo",
        usersDropdown: true,
        branchDropdown: true,
        designationDropdown: true,
        method: "post",
        action: "add",
        url: `${baseApi}/team`,
        getEditValue: `${baseApi}/getmemoById`,

        inputFields: [],
      },
    };
  },
  mounted() {
    const userData = JSON.parse(localStorage.getItem("UserRights"));
    const role = JSON.parse(localStorage.getItem("userData")).role;
    if (role !== "admin") {
      userData.map((item) => {
        this.edit = item.edit;
        this.add = item.add;
        this.canDelete = item.delete;
        if (item.modulename == "Memo") {
          if (item.edit !== 1 && item.add !== 1 && item.delete !== 1 && item.view !== 1) {
            this.$router.push("/");
          }
        }
      });
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
